// Design system tokens — all CSS custom properties injected via Global styles

export const cssVars = `
  :root {
    --bg-base: #080d1a;
    --bg-surface: #0e1525;
    --bg-surface-hover: #131e33;
    --bg-border: #1e2d45;

    --text-primary: #e8edf5;
    --text-secondary: #6b8099;
    --text-muted: #3d5068;

    --accent-cyan: #00c875;
    --accent-green: #00c875;
    --accent-yellow: oklch(0.88 0.19 110);
    --accent-amber: #f59500;
    --accent-red: #e05050;

    --accent-cyan-glow: rgba(0, 200, 117, 0.14);
    --accent-green-glow: rgba(0, 200, 117, 0.12);
    --accent-yellow-glow: oklch(0.88 0.19 110 / 0.14);
    --accent-amber-glow: rgba(245, 149, 0, 0.12);
    --accent-red-glow: rgba(224, 80, 80, 0.12);

    --sidebar-width: 220px;
    --page-padding-x: 24px;
    --page-padding-y: 32px;
    --card-padding: 20px;
    --section-gap: 24px;
    --table-row-height: 48px;
    --radius-card: 8px;
    --radius-btn: 6px;
    --radius-badge: 4px;

    font-family: 'Inter', system-ui, -apple-system, sans-serif;
  }

  * { box-sizing: border-box; }

  html, body, #mount {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    background: var(--bg-base);
    color: var(--text-primary);
    font-size: 14px;
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
  }

  a { color: var(--accent-cyan); text-decoration: none; }
  a:hover { opacity: 0.8; text-decoration: none; }

  @keyframes shimmer {
    from { background-position: 200% 0 }
    to   { background-position: -200% 0 }
  }

  @keyframes fadeIn  { from { opacity: 0 } to { opacity: 1 } }
  @keyframes modalIn { from { opacity: 0; transform: scale(0.96) } to { opacity: 1; transform: scale(1) } }

  @keyframes pageIn {
    from { opacity: 0; transform: translateY(8px) }
    to   { opacity: 1; transform: translateY(0) }
  }

  @keyframes cardIn {
    from { opacity: 0; transform: translateY(6px) }
    to   { opacity: 1; transform: translateY(0) }
  }

  @keyframes signInWordmark {
    from { opacity: 0; transform: translateY(-6px) }
    to   { opacity: 1; transform: translateY(0) }
  }

  @keyframes signInCard {
    from { opacity: 0; transform: translateY(10px) }
    to   { opacity: 1; transform: translateY(0) }
  }

  @keyframes cardPulse {
    0%, 100% { box-shadow: 0 0 0 1px rgba(0,0,0,0.5), 0 24px 64px rgba(0,0,0,0.6), 0 0 60px rgba(0,200,117,0.03); }
    50%       { box-shadow: 0 0 0 1px rgba(0,200,117,0.12), 0 24px 64px rgba(0,0,0,0.6), 0 0 80px rgba(0,200,117,0.07); }
  }
`;
